// @flow
import * as React from 'react'
import styled from '@emotion/styled'
import { colors, media } from '@toggl/style'
import * as text from '../text'
import type { ComponentType } from 'react'

export default function OverlapImage({
  image,
  children,
}: {
  image: React.Node,
  children: React.Node[],
}) {
  return (
    <Root>
      <ImageWrapper>{image}</ImageWrapper>
      <Content>{children}</Content>
    </Root>
  )
}

const Root: ComponentType<any> = styled.div`
  color: ${colors.beige};
  max-width: 1200px;
  margin: auto;
  ${text.paragraph2};

  ${media.mq[1]} {
    display: flex;
    align-items: center;
  }

  h3 {
    ${text.heading3};
    color: ${(p) => p.theme.primary};
  }

  ul {
    margin-top: 45px;
    line-height: 1.6;
  }

  span {
    margin-top: 13px;
    display: block;
    ${text.paragraph2};
  }
`
const ImageWrapper = styled.div`
  line-height: 0;
  img {
    width: 100%;
  }
  ${media.mq[1]} {
    z-index: 30;
    max-width: 30%;
    flex: 1;
  }
`
const Content = styled.div`
  background: ${colors.darkPurple};
  z-index: 20;
  padding: 30px;
  ul {
    padding: 0;
    margin-left: 20px;
  }
  ${media.mq[1]} {
    padding: 5% 5% 5% 20%;
    margin-left: -15%;
    flex: 2;
  }
`
